import React from 'react';
import { useParams } from 'react-router-dom';
import { fetchArticle } from '../services/AppService';
import { Container, Typography, Box, Button, Stack, Avatar } from '@mui/material';
import { BuildOutlined, BookOutlined, AccountCircleOutlined, ArticleOutlined, EmailOutlined } from '@mui/icons-material';
import Header from '../components/blog/components/Header';
import Footer from '../components/blog/components/Footer';
import AppTheme from '../components/shared-theme/AppTheme';
import { ThemeProvider, createTheme, useColorScheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid2';
import Link from '@mui/material/Link';
import CircularProgress from '@mui/material/CircularProgress';

function ArticleDetail(props)
{
	const { slug } = useParams();
	const [article, setArticle] = React.useState(null);

	React.useEffect(() => {
		fetchArticle(slug)
			.then(response => setArticle(response.data))
			.catch(error => console.error('Error fetching article: ', error));
	}, [slug]);

	if (!article) {
		return (
    		<Box sx={{ display: 'flex' }}>
      			<CircularProgress />
    		</Box>
  		);
	}

	return (
		<>
		<AppTheme {...props}>
		<CssBaseline enableColorScheme />
		<Header />
		<Container
			maxWidth='lg'
			component='main'
			sx={{ display: 'flex', flexDirection: 'column', my: 16, gap: 4 }}
		>
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 4}}>
      		<div>
      		  <Typography variant="h1" gutterBottom>
      		    tdbax blog
      		  </Typography>
      		  <Typography>Some are notable, many are experiments. </Typography>
      		</div>

			<Typography variant='h2' gutterBottom>
			{/* xxx className */}
			{article.title}
			</Typography>

    		<div
    			className='article-content'
    			dangerouslySetInnerHTML={{ __html: article.clean_content }}
    		/>
    			<div className='article-meta'>
    				<p>
    					<strong>Tags:</strong>{' '}
    					{article.tags.map(tag => (
    						<span className='tag' key={tag}>
    							{tag}
    						</span>
    					))}
    				</p>
    				<p>
    					<strong>Author:</strong> {article.author}
    				</p>
    			</div>

		</Box>
		</Container>
		<Footer />
		</AppTheme>
		</>
    );
}

export default ArticleDetail
